import type { Tab } from './index';

interface ValuationDot { ticker:string; name:string; sector:string; marketCap:number; revenue:number; ptUpside:number; profitable:boolean; }
interface UnicornDot   { name:string; sector:string; valuation:number; funding:number; ipoScore:number; founded:number; }
interface SmartDot     { investor:string; type:string; holdings:number; estValue:number; conviction:number; }

type BubbleView = 'valuation' | 'unicorn' | 'smartmoney';

const BUBBLE_DATA = {
  valuation: [
    { ticker:'HAWK',  name:'HawkEye 360',      sector:'Defense/SIGINT',   marketCap:2.85,  revenue:0.118,  ptUpside:40, profitable:true  },
    { ticker:'PL',    name:'Planet Labs',       sector:'Space/EO',         marketCap:14.7,  revenue:0.308,  ptUpside:18, profitable:false },
    { ticker:'SATL',  name:'Satellogic',        sector:'Space/EO',         marketCap:0.907, revenue:0.0177, ptUpside:25, profitable:false },
    { ticker:'IONQ',  name:'IonQ',              sector:'Quantum',          marketCap:20.79, revenue:0.130,  ptUpside:42, profitable:false },
    { ticker:'KRMN',  name:'Karman Holdings',   sector:'Defense/Space HW', marketCap:13.5,  revenue:0.471,  ptUpside:64, profitable:true  },
    { ticker:'VOYG',  name:'Voyager Technologies',sector:'Space/Commercial',marketCap:3.8,  revenue:0.138,  ptUpside:30, profitable:false },
    { ticker:'FLY',   name:'Firefly Aerospace', sector:'Space/Launch',     marketCap:4.2,   revenue:0.160,  ptUpside:45, profitable:false },
    { ticker:'MDA',   name:'MDA Space',         sector:'Space/Robotics',   marketCap:3.1,   revenue:0.335,  ptUpside:20, profitable:true  },
    { ticker:'RXRX',  name:'Recursion Pharma',  sector:'Biotech/AI',       marketCap:1.2,   revenue:0.0355, ptUpside:99, profitable:false },
    { ticker:'CRSP',  name:'CRISPR Therapeutics',sector:'Gene Therapy',    marketCap:4.85,  revenue:0.100,  ptUpside:64, profitable:false },
    { ticker:'GENB',  name:'Generate Biomedicines',sector:'Biotech/AI',    marketCap:1.65,  revenue:0.020,  ptUpside:72, profitable:false },
    { ticker:'KLRA',  name:'Kailera Therapeutics', sector:'Biotech/GLP-1', marketCap:2.1,   revenue:0.005,  ptUpside:50, profitable:false },
    { ticker:'CBRS',  name:'Cerebras Systems',  sector:'AI Chips',         marketCap:39.82, revenue:0.510,  ptUpside:35, profitable:false },
    { ticker:'XNDU',  name:'Xanadu Quantum',    sector:'Quantum',          marketCap:0.8,   revenue:0.0046, ptUpside:80, profitable:false },
    { ticker:'INFQ',  name:'Infleqtion',        sector:'Quantum',          marketCap:1.8,   revenue:0.015,  ptUpside:60, profitable:false },
  ] as ValuationDot[],
  unicorn: [
    { name:'Anduril',           sector:'Defense/Autonomous', valuation:61,   funding:11.96, ipoScore:90, founded:2017 },
    { name:'Shield AI',         sector:'Defense/Aviation',   valuation:12.7, funding:2.0,   ipoScore:80, founded:2015 },
    { name:'Saronic',           sector:'Defense/Naval',      valuation:9.25, funding:2.35,  ipoScore:75, founded:2022 },
    { name:'Helsing',           sector:'Defense/AI',         valuation:18,   funding:2.0,   ipoScore:55, founded:2021 },
    { name:'Skydio',            sector:'Defense/Drones',     valuation:4.4,  funding:0.966, ipoScore:65, founded:2014 },
    { name:'True Anomaly',      sector:'Space Defense',      valuation:2.2,  funding:1.0,   ipoScore:45, founded:2022 },
    { name:'CHAOS Industries',  sector:'Defense/EW',         valuation:4.5,  funding:0.93,  ipoScore:35, founded:2022 },
    { name:'Epirus',            sector:'Directed Energy',    valuation:1.35, funding:0.55,  ipoScore:40, founded:2018 },
    { name:'Altos Labs',        sector:'Longevity',          valuation:4.0,  funding:3.0,   ipoScore:35, founded:2022 },
    { name:'Retro Biosciences', sector:'Longevity',          valuation:5.0,  funding:1.2,   ipoScore:40, founded:2022 },
    { name:'Insilico Medicine', sector:'Biotech/AI',         valuation:1.0,  funding:0.45,  ipoScore:60, founded:2014 },
    { name:'Kraken',            sector:'Crypto Exchange',    valuation:20,   funding:0.8,   ipoScore:85, founded:2011 },
    { name:'OpenAI',            sector:'AI/LLM',             valuation:1000, funding:65,    ipoScore:80, founded:2015 },
    { name:'SpaceX',            sector:'Aerospace',          valuation:1750, funding:10,    ipoScore:75, founded:2002 },
    { name:'Anthropic',         sector:'AI/LLM',             valuation:300,  funding:12,    ipoScore:55, founded:2021 },
  ] as UnicornDot[],
  smartmoney: [
    { investor:'BlackRock',            type:'Asset Manager',     holdings:4, estValue:3.5,  conviction:90 },
    { investor:'Google Ventures',      type:'Corporate VC',      holdings:2, estValue:2.1,  conviction:85 },
    { investor:'Vanguard',             type:'Index Fund',        holdings:3, estValue:1.8,  conviction:70 },
    { investor:'ARK Invest',           type:'Active ETF',        holdings:2, estValue:0.9,  conviction:75 },
    { investor:'Andreessen Horowitz',  type:'VC',                holdings:3, estValue:2.4,  conviction:88 },
    { investor:'Thrive Capital',       type:'VC',                holdings:1, estValue:3.05, conviction:92 },
    { investor:'Morgan Stanley',       type:'Asset Manager',     holdings:2, estValue:1.2,  conviction:65 },
    { investor:'Tiger Global',         type:'Hedge Fund',        holdings:1, estValue:1.0,  conviction:70 },
    { investor:'General Catalyst',     type:'VC',                holdings:4, estValue:1.8,  conviction:82 },
    { investor:'Flagship Pioneering',  type:'Biotech VC',        holdings:1, estValue:0.4,  conviction:85 },
  ] as SmartDot[],
};

const SECTOR_COLORS: Record<string, string> = {
  'Defense/SIGINT':'#00d4ff','Space/EO':'#00ff9d','Space/Commercial':'#34d399','Space/Launch':'#6ee7b7',
  'Space/Robotics':'#a7f3d0','Defense/Space HW':'#22d3ee','Quantum':'#a78bfa','Biotech/AI':'#f472b6',
  'Gene Therapy':'#fb7185','Biotech/GLP-1':'#f9a8d4','AI Chips':'#fbbf24','Defense/Autonomous':'#00d4ff',
  'Defense/Aviation':'#38bdf8','Defense/Naval':'#0ea5e9','Defense/AI':'#7dd3fc','Defense/Drones':'#93c5fd',
  'Space Defense':'#c084fc','Defense/EW':'#e879f9','Directed Energy':'#f0abfc','Defense/Software':'#818cf8',
  'Longevity':'#34d399','Crypto Exchange':'#fbbf24','AI/LLM':'#f472b6','Aerospace':'#60a5fa',
  'Asset Manager':'#00d4ff','Corporate VC':'#a78bfa','Index Fund':'#22d3ee','Active ETF':'#f472b6',
  'VC/PE':'#00ff9d','PE Defense':'#38bdf8','Hedge Fund':'#fbbf24','VC':'#fb923c','Biotech VC':'#f472b6',
};

export class BubbleChartsTab implements Tab {
  readonly id = 'bubbles';
  private currentView: BubbleView = 'valuation';
  private rendered = false;

  init(): void {
    document.querySelectorAll<HTMLElement>('[data-bubble-view]').forEach(btn =>
      btn.addEventListener('click', () => this.switchView(btn.dataset.bubbleView as BubbleView)),
    );
    window.addEventListener('resize', () => { if (this.rendered) this.render(false); });
  }

  render(first = true): void {
    this.rendered = true;
    if (first) this.switchView('valuation');
    else this.renderChart(this.currentView);
  }

  private switchView(view: BubbleView): void {
    this.currentView = view;
    const descs: Record<BubbleView, string> = {
      valuation:  'Bubble size = Analyst PT upside % · Color = Sector · Click bubble to chart',
      unicorn:    'Bubble size = IPO likelihood score · Color = Sector · X = Total funding · Y = Valuation',
      smartmoney: 'Bubble size = Conviction score · Color = Investor type · X = # Holdings · Y = Est. position value ($B)',
    };
    const sizeLegends: Record<BubbleView, string> = {
      valuation:  'Larger bubble =<br>Higher analyst<br>price target upside %',
      unicorn:    'Larger bubble =<br>Higher IPO<br>likelihood score',
      smartmoney: 'Larger bubble =<br>Higher conviction<br>score (0-100)',
    };

    (['valuation','unicorn','smartmoney'] as BubbleView[]).forEach(v => {
      const btn = document.getElementById(`bv-${v}`);
      if (!btn) return;
      const active = v === view;
      btn.style.background  = active ? 'rgba(0,212,255,0.15)' : 'transparent';
      btn.style.borderColor = active ? 'rgba(0,212,255,0.4)'  : 'var(--border)';
      btn.style.color       = active ? 'var(--accent)'        : 'var(--text3)';
    });

    (document.getElementById('bubble-view-desc') as HTMLElement).textContent   = descs[view];
    (document.getElementById('bubble-size-legend') as HTMLElement).innerHTML   = sizeLegends[view];
    this.renderChart(view);
  }

  private renderChart(view: BubbleView): void {
    const svg     = document.getElementById('bubble-svg') as SVGSVGElement | null;
    const tooltip = document.getElementById('bubble-tooltip') as HTMLElement | null;
    const selEl   = document.getElementById('bubble-selected') as HTMLElement | null;
    if (!svg || !tooltip || !selEl) return;

    svg.innerHTML = '';
    const W      = svg.clientWidth || (svg.parentElement?.clientWidth ?? 800);
    const H      = 520;
    const margin = { top:40, right:20, bottom:50, left:70 };
    const iW     = W - margin.left - margin.right;
    const iH     = H - margin.top  - margin.bottom;
    const ns     = 'http://www.w3.org/2000/svg';

    const g = document.createElementNS(ns, 'g');
    g.setAttribute('transform', `translate(${margin.left},${margin.top})`);
    svg.appendChild(g);

    type AnyDot = { [key: string]: any };
    let data: AnyDot[], xKey: string, yKey: string, sizeKey: string, labelKey: string, colorKey: string, xLabel: string, yLabel: string;

    if (view === 'valuation') {
      data=BUBBLE_DATA.valuation; xKey='revenue'; yKey='marketCap'; sizeKey='ptUpside'; labelKey='ticker'; colorKey='sector'; xLabel='Revenue TTM ($B)'; yLabel='Market Cap ($B)';
    } else if (view === 'unicorn') {
      data=BUBBLE_DATA.unicorn; xKey='funding'; yKey='valuation'; sizeKey='ipoScore'; labelKey='name'; colorKey='sector'; xLabel='Total Funding ($B)'; yLabel='Valuation ($B)';
    } else {
      data=BUBBLE_DATA.smartmoney; xKey='holdings'; yKey='estValue'; sizeKey='conviction'; labelKey='investor'; colorKey='type'; xLabel='# Holdings'; yLabel='Est. Position Value ($B)';
    }

    const xVals = data.map(d => d[xKey] as number);
    const yVals = data.map(d => d[yKey] as number);
    const sVals = data.map(d => d[sizeKey] as number);
    const xMin  = Math.min(...xVals)*0.8, xMax = Math.max(...xVals)*1.2;
    const yMax  = Math.max(...yVals)*1.15;
    const sMin  = Math.min(...sVals), sMax = Math.max(...sVals);

    const scaleLog = (domain: [number,number], range: [number,number]) => {
      const ld0 = Math.log(Math.max(domain[0],0.001)), ld1 = Math.log(Math.max(domain[1],0.001));
      return (v: number) => range[0] + (Math.log(Math.max(v,0.001))-ld0)/(ld1-ld0)*(range[1]-range[0]);
    };
    const scaleLinear = (domain: [number,number], range: [number,number]) =>
      (v: number) => range[0] + (v-domain[0])/(domain[1]-domain[0])*(range[1]-range[0]);

    const xScale = xMax > 10 ? scaleLog([Math.max(xMin,0.001),xMax],[0,iW]) : scaleLinear([xMin,xMax],[0,iW]);
    const yScale = yMax > 10 ? scaleLog([0.001,yMax],[iH,0]) : scaleLinear([0,yMax],[iH,0]);
    const rScale = scaleLinear([sMin,sMax],[8,36]);

    // Grid
    const gridG = document.createElementNS(ns,'g');
    for (let i=0;i<=5;i++) {
      const y=iH*i/5, x=iW*i/5;
      const hl=document.createElementNS(ns,'line'); hl.setAttribute('x1','0'); hl.setAttribute('x2',String(iW)); hl.setAttribute('y1',String(y)); hl.setAttribute('y2',String(y)); hl.setAttribute('stroke','rgba(30,52,72,0.5)'); hl.setAttribute('stroke-dasharray','3,3'); gridG.appendChild(hl);
      const vl=document.createElementNS(ns,'line'); vl.setAttribute('x1',String(x)); vl.setAttribute('x2',String(x)); vl.setAttribute('y1','0'); vl.setAttribute('y2',String(iH)); vl.setAttribute('stroke','rgba(30,52,72,0.5)'); vl.setAttribute('stroke-dasharray','3,3'); gridG.appendChild(vl);
    }
    g.appendChild(gridG);

    // Axis labels
    const mkText = (x: number, y: number, text: string, opts: Record<string,string>={}) => {
      const el = document.createElementNS(ns,'text');
      el.setAttribute('x',String(x)); el.setAttribute('y',String(y));
      el.setAttribute('fill','#7a9db5'); el.setAttribute('font-size','11'); el.setAttribute('font-family','Space Mono,monospace');
      for (const [k,v] of Object.entries(opts)) el.setAttribute(k,v);
      el.textContent = text; return el;
    };
    const xAxisG = document.createElementNS(ns,'g'); xAxisG.setAttribute('transform',`translate(0,${iH})`);
    const xLine  = document.createElementNS(ns,'line'); xLine.setAttribute('x1','0'); xLine.setAttribute('x2',String(iW)); xLine.setAttribute('stroke','var(--border)'); xAxisG.appendChild(xLine);
    xAxisG.appendChild(mkText(iW/2,40,xLabel,{'text-anchor':'middle'})); g.appendChild(xAxisG);
    const yAxisG = document.createElementNS(ns,'g');
    const yLine  = document.createElementNS(ns,'line'); yLine.setAttribute('y1','0'); yLine.setAttribute('y2',String(iH)); yLine.setAttribute('stroke','var(--border)'); yAxisG.appendChild(yLine);
    yAxisG.appendChild(mkText(-iH/2,-52,yLabel,{'text-anchor':'middle','transform':'rotate(-90)'})); g.appendChild(yAxisG);

    // Bubbles
    const sectors = new Set<string>();
    for (const d of data) {
      const cx = xScale(d[xKey] as number), cy = yScale(d[yKey] as number), r = rScale(d[sizeKey] as number);
      const color = SECTOR_COLORS[d[colorKey] as string] ?? '#7a9db5';
      if (isNaN(cx)||isNaN(cy)) continue;
      sectors.add(d[colorKey] as string);

      const cg = document.createElementNS(ns,'g'); cg.style.cursor='pointer';
      const circle = document.createElementNS(ns,'circle');
      circle.setAttribute('cx',String(cx)); circle.setAttribute('cy',String(cy)); circle.setAttribute('r',String(r));
      circle.setAttribute('fill',color); circle.setAttribute('fill-opacity','0.25');
      circle.setAttribute('stroke',color); circle.setAttribute('stroke-width','1.5'); circle.style.transition='all 0.2s';

      const label = document.createElementNS(ns,'text');
      const lt = (d[labelKey] as string); label.setAttribute('x',String(cx)); label.setAttribute('y',String(cy+4));
      label.setAttribute('text-anchor','middle'); label.setAttribute('fill',color);
      label.setAttribute('font-size',r>20?'10':'9'); label.setAttribute('font-family','Space Mono,monospace'); label.setAttribute('font-weight','700');
      label.textContent = lt.length > 8 ? lt.substring(0,7)+'…' : lt;

      cg.appendChild(circle); cg.appendChild(label);
      cg.addEventListener('mouseenter', () => {
        circle.setAttribute('fill-opacity','0.5'); circle.setAttribute('r',String(r+4));
        selEl.innerHTML = `<div style="font-weight:700;color:${color};margin-bottom:4px;">${lt}</div>`;
        if (view==='valuation') {
          const dd=d as ValuationDot;
          tooltip.innerHTML=`<strong style="color:${color};">${dd.ticker}</strong><br>${dd.name}<br><br>Market Cap: <strong>$${dd.marketCap}B</strong><br>Revenue TTM: <strong>$${dd.revenue}B</strong><br>Analyst PT Upside: <strong style="color:var(--green);">+${dd.ptUpside}%</strong><br>Profitable: <strong style="color:${dd.profitable?'var(--green)':'var(--red)'};">${dd.profitable?'Yes':'No'}</strong><br>Sector: <span style="color:${color};">${dd.sector}</span>`;
        } else if (view==='unicorn') {
          const dd=d as UnicornDot;
          tooltip.innerHTML=`<strong style="color:${color};">${dd.name}</strong><br><br>Valuation: <strong>$${dd.valuation}B</strong><br>Total Raised: <strong>$${dd.funding}B</strong><br>IPO Likelihood: <strong style="color:var(--warn);">${dd.ipoScore}/100</strong><br>Founded: <strong>${dd.founded}</strong><br>Sector: <span style="color:${color};">${dd.sector}</span>`;
        } else {
          const dd=d as SmartDot;
          tooltip.innerHTML=`<strong style="color:${color};">${dd.investor}</strong><br>Type: ${dd.type}<br><br>Holdings: <strong>${dd.holdings}</strong><br>Est. Value: <strong>$${dd.estValue}B</strong><br>Conviction: <strong style="color:var(--accent);">${dd.conviction}/100</strong>`;
        }
        tooltip.style.display='block';
      });
      cg.addEventListener('mousemove', (e: MouseEvent) => {
        const sr = svg.getBoundingClientRect();
        let tx = e.clientX-sr.left+15, ty = e.clientY-sr.top-10;
        if (tx+220>W) tx-=230;
        tooltip.style.left=tx+'px'; tooltip.style.top=ty+'px';
      });
      cg.addEventListener('mouseleave', () => { circle.setAttribute('fill-opacity','0.25'); circle.setAttribute('r',String(r)); tooltip.style.display='none'; });
      if (view==='valuation') {
        cg.addEventListener('click', () => { (window as any).loadChartTicker?.((d as ValuationDot).ticker); });
      }
      g.appendChild(cg);
    }

    // Legend
    const legEl = document.getElementById('bubble-legend');
    if (legEl) {
      legEl.innerHTML = [...sectors].map(s => {
        const c = SECTOR_COLORS[s] ?? '#7a9db5';
        return `<div style="display:flex;align-items:center;gap:6px;"><span style="width:10px;height:10px;border-radius:50%;background:${c};flex-shrink:0;"></span><span style="color:${c};font-size:10px;">${s}</span></div>`;
      }).join('');
    }
  }
}
